import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a42fa79"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("the  "),
  /*#__PURE__*/_createElementVNode("span", null, "doomsday"),
  /*#__PURE__*/_createTextVNode("  rule")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" A mathematical party-trick to "),
  /*#__PURE__*/_createElementVNode("strong", null, "calculate the weekday for (almost) any given date."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This app just demonstrates the step by step calculations and provides a practice mode. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please refer to the "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "external-link",
    href: "https://en.wikipedia.org/wiki/Doomsday_rule",
    target: "_blank",
    rel: "noopener"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Wikipedia article"),
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      })
    ])
  ]),
  /*#__PURE__*/_createTextVNode(" for an in-depth description of the method and variations. ")
], -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, _hoisted_3))
}